import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-number-column',
    templateUrl: './number-column.component.html',
    styleUrls: ['./number-column.component.scss'],
    standalone: false
})
export class NumberColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }

  get format(): string {
    let numberFormat = this.field?.settings?.format;
    if (!numberFormat) {
      numberFormat = 'NUMBER';
    }

    return numberFormat;
  }

  constructor() {}

  ngOnInit(): void {}
}
